export default function HeroSection({className, ...props}) {

    return (
        <div className={`bg-[#F0F7FF] hidden lg:flex flex-row pl-[7rem]  ${className}`}>
            <div className={"flex flex-col gap-3 my-[7rem] flex-[2]"}>
                <p className={"text-[2rem] 2xl:text-[2.5rem] 3xl:text-[3.3125rem] font-poppins font-extrabold text-black"}>
                    Our Community Conversation
                </p>

            </div>
            <div className={'flex-[2]  flex justify-end items-end '}>
                <div className={"relative flex  "}>
                    <img src={"/images/halfCircle.svg"}  alt={"bg"}/>
                    <div className={"absolute bottom-0 w-full"} >
                        <img src={"/images/community-image.png"} className={"w-[80%] xl:w-auto m-auto "}  alt={"person"}/>

                    </div>
                </div>


            </div>
            <div className={"flex-1"}>
                {/*<img src={"/images/handscomm.png"} className={" w-[80%] 2xl:w-auto"}  alt={"hands"}/>*/}

            </div>
        </div>

    )
}